import { z } from "zod";
import { UserProfile } from "./user-profile";

export const UserSource = z.enum(["SignUp", "Invite", "SSO"]);

export const User = z.object({
  id: z.string(),
  email: z.string(),
  createdAt: z.coerce.date(),
  profile: UserProfile,
  loggedOutAt: z.coerce.date().optional(),
  isProtected: z.boolean(),
  source: UserSource.optional(),
});

export type UserSource = z.infer<typeof UserSource>;
export type User = z.infer<typeof User>;
